import { ColumnInfo, ColumnInfoList, DisplaySetting } from 'components/shared/display_setting'
import { Flex } from 'components/shared/flex'
import { TableCell } from 'components/shared/widget'
import { MaterialTaskSetData, TaskSet } from 'entities/task_set'
import { ReactNode, useMemo } from 'react'
import { ProgressBar } from 'react-bootstrap'
import { Link } from 'react-router-dom'
import { Form } from 'utils/hooks'
import { toDateText } from 'utils/util'
import { TaskSetViewModel } from 'view_models/task_set_view_model'

export const taskSetColumnInfoList = (form?: Form<Record<string, unknown>>): ColumnInfoList => {
    return {
        tableName: '',
        values: [
            { name: 'ID', th: true, width: 50, form: form, orderAttr: 'task_set_id', searchType: { name: 'id', type: 'multiple_text' } },
            { name: '作成日', th: true, width: 80, form: form, orderAttr: 'task_set_created_at', searchType: { name: 'created_at', type: 'date' } },
            { name: '完了日', th: true, width: 80, form: form, orderAttr: 'task_set_created_at', searchType: { name: 'created_at', type: 'date' } },
            { name: '作成者', th: true, width: 70, form: form, orderAttr: 'task_set_user_id' },
            { name: 'タグ', th: true, width: 70 },
            { name: 'グループID', th: true, width: 100, form: form, orderAttr: 'task_set_task_group_id', align: 'center' },
            { name: 'タイトル', th: true, minWidth: 200, form: form, orderAttr: 'task_set_title', searchType: { name: 'title', type: 'text' } },
            { name: '伝票番号(ゆうパック)', th: true, minWidth: 200},
            { name: '送付状番号(ヤマト)', th: true, minWidth: 200},
            { name: 'タスク数', th: true, width: 200, align: 'center' },
        ],
    }
}

export type TaskSetTableDataProps = {
    taskSet?: TaskSet
    displaySetting: DisplaySetting
}

export const TaskSetTableData = ({ taskSet, displaySetting }: TaskSetTableDataProps): JSX.Element => {
    if (!taskSet) {
        return (
            <>
                {displaySetting.columnInfoList.values.map((_: ColumnInfo, index: number) => {
                    if (displaySetting.hiddenList.includes(index)) {
                        return <></>
                    } else {
                        return <TableCell key={index}></TableCell>
                    }
                })}
            </>
        )
    }

    const createCells = useMemo(() => {
        const vm = new TaskSetViewModel(taskSet)
        return (
            <>
                <TableCell>{taskSet.id}</TableCell>
                <TableCell>{toDateText(taskSet.createdAt)}</TableCell>
                <TableCell>{toDateText(taskSet.completedAt)}</TableCell>
                <TableCell>{taskSet.user?.fullName}</TableCell>
                <TableCell>{vm.userGroup()}</TableCell>
                <TableCell align="center">
                    {taskSet.kind === 'MATERIAL' ? (
                        <Link to={`/tasks/materials?taskGroupId=${taskSet.taskGroupId}`}>{taskSet.taskGroupId}</Link>
                    ) : (
                        taskSet.taskGroupId
                    )}
                </TableCell>
                <TableCell>
                    {taskSet.title}
                    {(() => {
                        const data = vm.data()
                        if (!data) {
                            return
                        }
                        if (taskSet.kind === 'MATERIAL') {
                            return ` ${(data as MaterialTaskSetData).institution_name ?? '--'}`
                        }
                    })()}
                </TableCell>
                <TableCell>
                    {(() => {
                        const data = vm.data()
                        if (!data) {
                            return
                        }
                        if (taskSet.kind === 'MATERIAL') {
                            return ` ${(data as MaterialTaskSetData).slip_number_jp ?? '--'}`
                        }
                    })()}
                </TableCell>
                <TableCell>
                    {(() => {
                        const data = vm.data()
                        if (!data) {
                            return
                        }
                        if (taskSet.kind === 'MATERIAL') {
                            return ` ${(data as MaterialTaskSetData).slip_number_ym ?? '--'}`
                        }
                    })()}
                </TableCell>
                <TableCell align="center">
                    <Flex alignItems="center">
                        <div style={{ flexGrow: 1, marginRight: 0 }}>
                            <ProgressBar variant="primary" now={vm.completeRate()} label={`${vm.completeRate()}%`}></ProgressBar>
                        </div>
                        <div style={{ width: 40, textAlign: 'center' }}>
                            <div>
                                {vm.completeCount()} / {taskSet.tasks?.length}
                            </div>
                        </div>
                    </Flex>
                </TableCell>
            </>
        )
    }, [displaySetting.hiddenList, taskSet])

    return createCells.props.children.filter((_: ReactNode, index: number) => !displaySetting.hiddenList?.includes(index)).map((cell: ReactNode) => cell)
}
